export const en = {
  tweet_details: 'tweet details',
  tweets: 'tweets',
  tweet_likes: 'tweet likes',
  tweet_replies: 'tweet replies',
  tweet_retweets: 'tweet retweets',
  tweet_quotes: 'tweet quotes',
  publish_date: 'publish date',
  tweet_views: 'tweet views',
  tweet_bookmarks: 'tweet bookmarks',
  tweet_client: 'tweet client',
  tweet_type: 'tweet type',
  replies: 'replies',
  quotes: 'quotes',
  tweets_Table: 'tweets table',
  tweets: 'tweets',
  incomplete: 'incomplete',
  tweet_type: 'tweet type',
  tweet_id: 'tweet id',
  type_tweet_id: 'Type tweet ID',
  tweet: 'tweet',
  quotes: 'quotes',
  searchBy_tweet: 'search by tweet',
  searchBy_tweet_id: 'search by tweet id',
  search_by_influencer: 'search by influencer/entity',
  unanalyzed_entity_influencer: 'Unanalyzed Influencer/Entity',
  tweets_type: 'tweets type',
  incomplete_tweets: 'incomplete tweets',
  tweet_hashtags: 'tweet hashtags',
  tweet_media: 'tweet media',
  location: 'location',
  followers: 'followers',
  inf_ent: 'influencer/entity details',
  inf_ent_name: 'Influencer/Entity name',
  original: 'Original',
  quote: 'Quote',
  retweet: 'Retweet',
  reply: 'Reply',
  replies_sentiment: 'replies sentiment',
  quotes_sentiment: 'quotes sentiment',
  language: 'language',
  basic_data: 'basic data',
  replies_conv_data: 'replies conversations',
  regrab_replies: 'replies',
  invalid_tweet_id: 'Invalid tweet ID',
  duplicate_tweet: ' This tweet already exists in the system',
  tweet_exists_incomplete:
    'This tweet exists in the system before ,  click here to show details  ',
  add_tweet: 'Add new tweet',
  analyzed_hashtags: 'analyzed hashtags',
  un_analyzed_hashtags: 'un-analyzed hashtags',
  tweet_sentiment_analysis: 'tweet sentiment analysis',
  top_used_hashtags: 'Top used hashtags',
  selectGrab: 'select what to regrab for selected tweets before download',
  h: 'h',
  m: 'm',
  s: 's',
  un_analyzed_influencers: 'Un-analyzed Influencers/Entities',
  number_of_tweets: 'number of tweets',
};
export const ar = {
  number_of_tweets: 'عدد التغريدات',
  un_analyzed_influencers: 'المؤثرون / الكيانات الغير محللة',
  h: 'س',
  m: 'د',
  s: 'ث',
  tweet_sentiment_analysis: 'تحليل نسب الاراء للتغريدة',
  add_tweet: 'إضافه تغريده جديده ',
  tweet_exists_incomplete:
    ' التغريدة تم اضافتها من قبل ، انقر هنا لعرض التفاصيل ',
  duplicate_tweet: 'هذه التغريده تم إضافتها من قبل',
  invalid_tweet_id: 'رقم تعريف التغريده غير صحيح',
  tweet_details: 'تفاصيل التغريدة',
  tweet_likes: 'عدد الإعجابات',
  tweet_replies: 'عدد الردود',
  tweet_retweets: 'عدد إعادة التغريدات',
  tweet_quotes: 'عدد الإقتباسات',
  publish_date: 'توقيت النشر',
  tweet_views: 'عدد المشاهدات',
  tweet_bookmarks: 'عدد العلامات المرجعية',
  tweet_client: 'الحساب المستخدم فى التغريدة',
  tweet_type: 'نوع التغريدة',
  replies: 'الردود',
  tweet: 'التغريدة',
  quotes: 'الإقتباسات',
  tweets_Table: 'جدول التغريدات',
  tweets: 'التغريدات',
  incomplete: 'غير مكتملة',
  tweet_type: 'نوع التغريدة',
  tweet_id: 'رقم تعريف التغريدة',
  searchBy_tweet: 'ابحث بواسطه التغريدة',
  searchBy_tweet_id: 'ابحث بواسطه رقم تعريف التغريدة ',
  search_by_influencer: 'ابحث بواسطه المؤثر / الكيان',
  unanalyzed_entity_influencer: 'المؤثر /الكيان الذي لم يتم تحليله',
  tweets_type: 'نوع التغريدات',
  incomplete_tweets: 'التغريدات الغير مكتملة',
  tweet_hashtags: 'الهاشتاقات المستخدمة فى التغريدة',
  tweet_media: 'وسائط التغريدة',
  location: 'الموقع الجغرافى',
  followers: 'المتابعين',
  inf_ent: 'بيانات المؤثر / الكيان',
  inf_ent_name: 'اسم المؤثر/الكيان',
  followers: 'المتابعين',
  original: 'الاصلي',
  quote: 'الإقتباس',
  type_tweet_id: 'ادخل رقم تعريف التغريدة',
  retweet: 'إعادة تغريد',
  reply: 'الرد',
  replies_sentiment: 'نسب آراء الردود',
  quotes_sentiment: 'نسب آراء الإقتباسات',
  language: 'لغة',
  basic_data: 'البيانات الأساسية',
  replies_conv_data: 'المحادثة للتغريدة',
  un_analyzed_hashtags: 'الهاشتاقات غير المحللة',
  analyzed_hashtags: 'الهاشتاقات المحللة',
  regrab_replies: 'الردود',
  top_used_hashtags: ' الهاشتاقات الأكثر إستخداماً',
  selectGrab: 'اختار ماذا يتم جلبه للتغريدات المختارة قبل التحميل',
};
